export default {
  data: () => ({
    badgeVisible: false,
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  }),
  mounted() {
    this.checkRecaptchaIsMountedAndVisible();
  },
  methods: {
    checkRecaptchaIsMountedAndVisible() {
      const el = document.createElement('script');
      el.setAttribute(
        'src',
        `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`,
      );
      document.querySelector('head').appendChild(el);
      el.onload = () => {
        window.grecaptcha.enterprise.ready(() => {
          this.badgeVisible = true;
        });
      };
    },
    setBadgeVisibility(visible) {
      const badges = document.querySelectorAll('.grecaptcha-badge');
      badges.forEach((el) => {
        el.style.setProperty('visibility', visible ? 'visible' : 'hidden');
      });
      this.badgeVisible = visible;
    },
  },
};
